import { Component } from '@angular/core';

@Component({
  selector: 'app-modal-returns-information',
  templateUrl: './modal-returns-information.component.html',
  styleUrls: ['./modal-returns-information.component.scss']
})
export class ModalReturnsInformationComponent {
  public isModalReturnsInformationShow: boolean = false;
  public isDarkBackground: boolean = false;

  openModalReturnsInformationShow() {
    this.isModalReturnsInformationShow = true;
    this.isDarkBackground = true;
  }

  closeModal() {
    this.isModalReturnsInformationShow = false;
    this.isDarkBackground = false;
  }
}
